export const BASE_URL = '/api';
export const MOCK_BASE_URL = 'http://localhost:3050';
